theme.imageOverlayBoxAnimation = function() {
  setTimeout(function(){ 
    $(".image-with-text-wrapper .block-wrapper .content-box .content-inner-wrap").addClass("active"); 
  }, 2500);
  setTimeout(function(){ 
    $(".image-with-text-wrapper .block-wrapper .content-box .heading").addClass("active"); 
  }, 5000);
  setTimeout(function(){
    $(".image-with-text-wrapper .block-wrapper .content-box .sub-title").addClass("active"); 
  }, 7500);
  setTimeout(function(){
    $(".image-with-text-wrapper .block-wrapper .content-box .bttn--secondary").addClass("active"); 
  }, 10000);
  
//   setTimeout(function(){
//     $(".slideshow__content").addClass("active"); 
//   }, 2500);  

  setTimeout(function(){
    $(".slideshow__heading").addClass("active"); 
  }, 2000);
  
  setTimeout(function(){
    $(".slideshow__subheading").addClass("active"); 
  }, 4000);
  
  setTimeout(function(){
    $(".slideshow__link").addClass("active"); 
  }, 6000);

    setTimeout(function(){
    $(".content-overlay__inner").addClass("active"); 
  }, 2000);  

  setTimeout(function(){
    $(".content-overlay__heading").addClass("active"); 
  }, 2500);  
  
  setTimeout(function(){
    $(".content-overlay__subheading").addClass("active"); 
  }, 5000);  
  
  setTimeout(function(){
    $(".content-overlay__inner a").addClass("active"); 
  }, 7500);  
} 

theme.imageOverlayBoxAnimationRemove = function() {
  $(".content-overlay__inner, .content-overlay__heading, .content-overlay__subheading, .content-overlay__inner a, .slideshow__heading ,  .slideshow__subheading , .slideshow__link , .image-with-text-wrapper .block-wrapper .content-box .sub-title, .image-with-text-wrapper .block-wrapper .content-box .heading, .image-with-text-wrapper .block-wrapper .content-box .content-inner-wrap, .image-with-text-wrapper .block-wrapper .content-box .bttn--secondary").removeClass("active");
}

$(document).ready(function(){
    theme.init();
});

var $animation_elements = $('.content-box , .slideshow__content, .content-overlay__inner');
var $window = $(window);

function check_if_in_view() {
  var window_height = $window.height();
  var window_top_position = $window.scrollTop();
  var window_bottom_position = (window_top_position + window_height);
 
  $.each($animation_elements, function() {
    var $element = $(this);
    var element_height = $element.outerHeight();
    var element_top_position = $element.offset().top;
    var element_bottom_position = (element_top_position + element_height);
 
    //check to see if this current container is within viewport
    if ((element_bottom_position >= window_top_position) &&
        (element_top_position <= window_bottom_position)) {
      $element.addClass('in-view');
      theme.imageOverlayBoxAnimation();
    } else {
      $element.removeClass('in-view');
//       theme.imageOverlayBoxAnimationRemove();
    }
  });
}

$window.on('scroll resize', check_if_in_view);
$window.trigger('scroll');


